export default "__VITE_ASSET__b9cdc2f8__"